export type { Props as SummaryDumbFieldProps } from './summary-dumb';
export { default as SummaryDumbField } from './summary-dumb';
